var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { AchooTabsComponent } from '../../core/achoo-tabs/achoo-tabs.component';
import { WebUtils } from '../../utils/web.utils';
import { Router, ActivatedRoute } from '@angular/router';
import { Location as NgCommonLocation } from '@angular/common';
import { UserService } from '../../services/user.service';
import { AbstractAchooComponent } from '../abstract-achoo.component';
import { UserBilling } from '../../../models/Billing/billing-details';
import { UserBillingComponent } from '../user/user-billing/user-billing.component';
import { TranslateService } from '@ngx-translate/core';
import { AchooPopupComponent } from '../../core/achoo-popup/achoo-popup.component';
import { ModalService } from '../../services/modal/modal.service';
import { CompanyStatus } from '../../../models/common';
import { tap, catchError, concatMap } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
var AccountSettingTabs;
(function (AccountSettingTabs) {
    AccountSettingTabs["USER_SETTINGS"] = "user-settings";
    AccountSettingTabs["BILLING"] = "billing";
})(AccountSettingTabs || (AccountSettingTabs = {}));
var AccountSettingComponent = /** @class */ (function (_super) {
    __extends(AccountSettingComponent, _super);
    function AccountSettingComponent(router, translate, location, activatedRoute, modalService, userService) {
        var _this = _super.call(this, userService) || this;
        _this.router = router;
        _this.translate = translate;
        _this.location = location;
        _this.activatedRoute = activatedRoute;
        _this.modalService = modalService;
        _this.userService = userService;
        _this.accountTabs = AccountSettingTabs;
        _this.userBilling = new UserBilling();
        _this.userMonthlyUsage = { isLoading: true };
        _this.allowInactiveAccount = true;
        return _this;
    }
    AccountSettingComponent.prototype.ngOnInit = function () {
        var _this = this;
        _super.prototype.ngOnInit.call(this);
        this.activatedRoute.data.subscribe(function (data) {
            _this.tabKey = data.activeTab || AccountSettingTabs.USER_SETTINGS;
        });
    };
    AccountSettingComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        this.cancelCurrentLoadBilling();
    };
    AccountSettingComponent.prototype.companyChangeCallback = function (companyId) {
        this.clearThePricingOnChangeCompany();
        this.loadBilling(true);
    };
    AccountSettingComponent.prototype.loadBilling = function (forInitPage) {
        var _this = this;
        if (forInitPage === void 0) { forInitPage = false; }
        this.cancelCurrentLoadBilling();
        var oldBillingCustomerStatus = null;
        if (!forInitPage) {
            oldBillingCustomerStatus = this.userBilling.customerStatus;
        }
        this.userBilling.isLoading = true;
        this.userMonthlyUsage = { isLoading: true };
        this.shouldReloadPage = false;
        this._selfLoadingBillingSubscription = this.userService.getUserBilling(this.companyId).pipe(tap(function (res) {
            _this.userBilling = Object.assign({}, res, {
                isLoading: false
            });
            _this.isAccountInactive = _this.isBillingCustomerStatusInactive(_this.userBilling.customerStatus);
            // loading page and change current account case
            if (forInitPage) {
                // for the case BE has not synced customer status with latest subscription status
                // or FE loaded customer status is old
                _this.shouldReloadPage = _this.isAccountInactive !== _this.isCurrentAdvertiserInactive();
                return;
            }
            // after close modal case
            _this.shouldReloadPage = _this.shouldReloadPageByCustomerStatusChange(oldBillingCustomerStatus, res.customerStatus);
        }), catchError(function (err) {
            _this.userBilling.isLoading = false;
            _this.modalService.close();
            _this.errorMessage = _this.translate.instant('user_billing.load_subscription_error');
            _this.modalService.open(_this.errorNotification, null, true);
            return of(null);
        })).pipe(concatMap(function () {
            return _this.userService.getUserMonthlyUsage(_this.companyId).pipe(tap(function (res) {
                if (res && res.data) {
                    _this.userMonthlyUsage = __assign({}, res.data, { isLoading: false });
                }
            }), catchError(function (error) {
                _this.userMonthlyUsage = { isLoadingError: true };
                _this.modalService.close();
                _this.errorMessage = _this.translate.instant('user_billing.load_monthly_usage_error');
                _this.modalService.open(_this.errorNotification, null, true);
                WebUtils.reportErrorToSentry('Loading user monthly usage fails.', error);
                return of(null);
            }));
        })).subscribe();
    };
    AccountSettingComponent.prototype.clearThePricingOnChangeCompany = function () {
        if (this.userBillingDetails && this.userBillingDetails.userBillingDetails) {
            this.userBillingDetails.userBillingDetails.invoicedNextMonth = null;
        }
    };
    AccountSettingComponent.prototype.replaceTab = function (tabKey) {
        if (!tabKey) {
            this.tabKey = AccountSettingTabs.USER_SETTINGS;
        }
        else {
            this.tabKey = tabKey;
        }
        var params = {
            queryParams: {
                activeAccount: this.userService.getCompanyId()
            }
        };
        var url = this.router.createUrlTree(['/account-settings', tabKey], params);
        this.location.replaceState(url.toString());
    };
    Object.defineProperty(AccountSettingComponent.prototype, "header", {
        get: function () {
            if (this.tabKey === AccountSettingTabs.BILLING) {
                return this.translate.instant('account_settings.billing_header');
            }
            return this.translate.instant('account_settings.user_setting_header');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AccountSettingComponent.prototype, "subheader", {
        get: function () {
            if (this.tabKey === AccountSettingTabs.BILLING) {
                return this.translate.instant('account_settings.billing_sub_header');
            }
            return this.translate.instant('account_settings.user_setting_sub_header');
        },
        enumerable: true,
        configurable: true
    });
    AccountSettingComponent.prototype.reloadBilling = function () {
        this.loadBilling();
    };
    AccountSettingComponent.prototype.cancelCurrentLoadBilling = function () {
        if (this._selfLoadingBillingSubscription) {
            this._selfLoadingBillingSubscription.unsubscribe();
        }
    };
    AccountSettingComponent.prototype.shouldReloadPageByCustomerStatusChange = function (oldStatus, currentStatus) {
        // just show message for case inactive -> active
        var isOldStatusInactive = this.isBillingCustomerStatusInactive(oldStatus);
        if (!isOldStatusInactive) {
            return false;
        }
        return !this.isBillingCustomerStatusInactive(currentStatus);
    };
    AccountSettingComponent.prototype.isBillingCustomerStatusInactive = function (customerStatus) {
        return customerStatus === CompanyStatus.BLOCKED
            || customerStatus === CompanyStatus.CHURNED
            || customerStatus === CompanyStatus.FUTURE;
    };
    AccountSettingComponent.prototype.isCurrentAdvertiserInactive = function () {
        var ad = this.userService.getCurrentAdvertiser();
        return ad && ad.inactive;
    };
    return AccountSettingComponent;
}(AbstractAchooComponent));
export { AccountSettingComponent };



// WEBPACK FOOTER //
// ./src/app/main/account-setting/account-setting.component.ts.pre-build-optimizer.js